var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestDemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 16.221,18.477 11.783,18.477 11.783,23.656 16.221,23.656  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 11.783,
    y1: 21.193,
    x2: 16.221,
    y2: 21.193
  })), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 29.544,17.793 29.544,22.609 30.767,23.729 35.831,23.729 36.817,22.699 36.817,17.758  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 44.563,18.477 40.112,18.477 40.112,23.674 44.563,23.674  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 40.112,
    y1: 21.203,
    x2: 44.563,
    y2: 21.203
  })), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 53.499,19.506 53.499,18.475 47.351,18.475 47.351,21.148 53.403,21.148 53.403,23.752 47.319,23.752 47.319,22.465  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 2.188,24.328 2.188,18.627 2.391,18.412 8.125,18.412 8.335,18.596 8.335,21.371 2.188,21.371  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 7.223,21.371 8.413,22.682 8.413,24.328  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 20.274,23.863 25.487,23.863 25.859,23.459 25.859,18.793 25.487,18.418 20.049,18.418 19.711,18.729 19.711,23.426  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 23.361,
    y1: 22.359,
    x2: 26.771,
    y2: 24.451
  })), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 58.644,
    y1: 18.477,
    x2: 58.644,
    y2: 24.299
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 61.812,
    y1: 18.477,
    x2: 55.464,
    y2: 18.477
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 27.937,35.424 30.889,29.635 31.473,29.609 34.437,35.424  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 29.005,
    y1: 33.328,
    x2: 33.347,
    y2: 33.328
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 13.562,45.613 19.338,45.613 19.709,45.209 19.709,40.543 19.338,40.168 13.562,40.168 13.562,40.479 13.562,45.176  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 28.066,40.434 23.627,40.434 23.627,45.615 28.066,45.615  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 23.627,
    y1: 43.152,
    x2: 28.066,
    y2: 43.152
  })), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 30.908,46.242 30.908,40.461 31.183,40.465 35.204,45.83 35.815,45.838 39.624,40.396 39.907,40.398 39.907,46.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    points: " 44.132,45.635 49.347,45.635 49.718,45.23 49.718,40.564 49.347,40.189 43.907,40.189 43.569,40.5 43.569,45.197  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestDemo);
export default __webpack_public_path__ + "static/media/requestDemo.f16f3795dc133290cac1da6be67ac93a.svg";
export { ForwardRef as ReactComponent };